export default "__VITE_ASSET__BkgT6nA___"